/* esm.sh - rxjs@7.8.1/dist/esm/internal/util/identity */
function n(t){return t}export{n as identity};
//# sourceMappingURL=identity.mjs.map